import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { TomosSection } from './components/TomosSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-mystic-900 text-white selection:bg-gold selection:text-mystic-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SocialProofToast data-id="element-2" />
      <HeroSection data-id="element-3" />
      <PainPointsSection data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}